// Version : 0.0.1
// Author : VIGNESH
// LastEdit : VIGNESH
// Last ADD : REMOVED UNWANTED REDUX AND ADDED COMMENTS
// MODFIED DATA : 07-12-2025

import { makeApiCall } from '../../_common/api.utils';
import { API_URL } from '../../const';

// Account Day Book Report Get
export const dayBookReportGet = (listData: any) => {
	const data = {
		AccountDayBookPostDataToken: listData,
	};
	const url = `${API_URL}fetchAccountDayBook`;
	return makeApiCall(url, data);
};
// accountDayBookReportGet
